import React from 'react';

interface DialogResultNameWithHighlightProps {
    name: string;
    highlight: string;
}

export const DialogResultNameWithHighlight = ({ name, highlight }: DialogResultNameWithHighlightProps) => {
    // Escape highlight string for regex
    highlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const nameParts = name.split(new RegExp(`(${highlight})`, 'gi'));

    return (
        <div>
            {nameParts.map((part, i) => (
                <span key={i} style={part.toLowerCase() === highlight.toLowerCase() ? { fontWeight: 'bold' } : {}}>
                    {part}
                </span>
            ))}
        </div>
    );
};
